import React from 'react';
import GmailAddonAdPicture from './gmail-addon-ad-picture';
import {useTranslation} from 'react-i18next';

function GmailAddonAd () {

	const { t } = useTranslation();
	return (
		<div className="mt-3">
			<GmailAddonAdPicture/>
			<div className="p-3 border-left border-right border-bottom text-center">
				<p>Let Gmail create and update your contacts from email</p>
				<a
					href={'https://workspace.google.com/marketplace/app/shared_contacts_ai_autoupdater_for_gmail/411072400724'}
					target="_blank"
					rel="noreferrer"
					aria-label="Get Gmail Addons"
					title="Get Gmail Addons"
					onClick={() => window.webful?.track('gmail_addon_clicked')}
					className="btn btn-primary text-truncate d-block">
					{t('gmailAddonBtn')}
				</a>
			</div>
		</div>
	)
}

export default GmailAddonAd;
